import TransferActivityPage, { getDefaultPageUI } from "components/pages/TransferActivityPage";
import ScheduledTransfersPage from "components/pages/TransferActivityPage/components/ScheduledTransfersPage";
import { BCMSStateManagerCRUD } from "bcms-react";

/**
 * @name CaptureTransfersScheduledExpanded
 * @returns {React.Component}
 * @description The capture component for the transfer activity page
 * showing the scheduled transfers and the first transfer showing details
 */
export default function CaptureTransfersScheduledExpanded(props) {
    // Initalize a new instance of BCMSStateManagerCRUD using the default page ui
    // updating hte content, scheduledTransfers and Accordion properties
    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
        // Sets the component to be used for the content
        .update([ "content" ], ScheduledTransfersPage)
        // Sets the tab to be selected
        .update([ "scheduledTransfers", "isActive" ], true)
        // Sets the accordion to be opened
        .update([ "Accordion_45" ], { isActive: true })
        .submit();

    // Return the TransferActivityPage passing the ui variable
    return <TransferActivityPage ui={ ui } />
}